// extracted by mini-css-extract-plugin
module.exports = {"container":"container--3FHOh","sidebar":"sidebar--11-CH","content":"content--24Y7P","inner":"inner--4_Dlt"};